const STORAGE_KEY = "gaole_support_case_seen";

type SeenMap = Record<string, string>;

function readMap(): SeenMap {
  try {
    return JSON.parse(localStorage.getItem(STORAGE_KEY) ?? "{}") as SeenMap;
  } catch {
    return {};
  }
}

/** Mark case activity as seen (ISO timestamp from API `updatedAt`). */
export function markSupportCaseSeen(caseId: string, updatedAt: string): void {
  const map = readMap();
  map[caseId] = updatedAt;
  localStorage.setItem(STORAGE_KEY, JSON.stringify(map));
}

export function isSupportCaseUnread(caseId: string, updatedAt: string, commentCount = 0): boolean {
  const seenAt = readMap()[caseId];
  if (!seenAt) return commentCount > 0;
  return new Date(updatedAt).getTime() > new Date(seenAt).getTime();
}
